(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');


      this.createObserver();
    }

    disconnectedCallback() {
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    

    

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // 2026 refresh: tapping a shop category in the phone menu while already on the shop page
  // only scrolls (no page load), so close the menu first or it stays open over the page.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.tf-drawer-sub__link');
    if (!link || new URL(link.href).pathname !== window.location.pathname) return;
    const drawer = link.closest('header-drawer');
    const summary = drawer && drawer.querySelector('#Details-menu-drawer-container > summary');
    if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, summary);
  });

  // 2026 refresh: the SHOP dropdown hangs from the header's bottom edge, so it needs the space
  // between the SHOP link and that edge.
  (() => {
    const setDropGap = () => {
      const menu = document.querySelector('.tf-shop-menu');
      const wrapper = document.querySelector('.header-wrapper');
      if (!menu || !wrapper) return;
      const gap = wrapper.getBoundingClientRect().bottom - menu.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--tf-drop-gap', Math.max(gap, 0) + 'px');
    };
    setDropGap();
    window.addEventListener('resize', setDropGap);
    window.addEventListener('load', setDropGap);
  })();

  } catch(e) { console.error(e); }
})();
})();
